<!--
 * @Description: 静态下拉组件（处理去掉null,""）
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2022-10-17 13:37:55
 * @LastEditors: mdb
-->
<template>
  <a-select
    allow-clear
    v-bind="$attrs"
    v-model:value="data"
    style="width: 100%"
    placeholder="请选择"
    :disabled="disabled"
    @change="change"
    :max-tag-count="pageMaxTagCount"
  />
</template>
<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
const props = defineProps({
  value: {
    type: [String, Number, Array]
  },
  maxTagCount: {
    type: [Number, String]
  },
  disabled: {
    type: Boolean,
    default: false
  },
  filterVal: {
    type: Array,
    default: () => [null, '', 0]
  }
})
const data = ref()
watch(
  () => props.value,
  (v) => {
    if (!v) {
      if (props.filterVal.includes(v)) {
        data.value = undefined
        return
      }
    }
    data.value = v
  },
  { immediate: true }
)
const pageMaxTagCount = computed(() => {
  if (props.maxTagCount) {
    return props.maxTagCount
  }
  if (props.disabled) {
    return 100
  }
  return 'responsive'
})
const emit = defineEmits(['update:value', 'change'])
const change = (value: any) => {
  emit('update:value', value)
  emit('change', value)
}
</script>
